module.exports = __webpack_public_path__ + "b185a80a88891be299f7dfd86c7fd813.png";